/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { customColors } from '@apollo/orbit';
import { css, jsx } from '@emotion/react';
import React from 'react';

import { ResizerStyles } from 'src/components/common/resizerStyles/ResizerStyles';
import { SplitPane } from 'src/components/common/splitPane/SplitPane';

import { InsightsL3Nav } from '../../operationsPage/insightsL3Nav/InsightsL3Nav';
import { useInsightsL3NavState } from '../../operationsPage/insightsL3Nav/useInsightsL3NavState';

interface FieldPageLayoutProps {
  children: React.ReactNode;
}

export const FieldPageLayout = (props: FieldPageLayoutProps) => {
  const { children } = props;
  const { isOpen, width, setWidth } = useInsightsL3NavState();

  if (!isOpen) {
    return <>{children}</>;
  }

  return (
    <div className="relative flex flex-1 flex-col">
      <ResizerStyles />
      <SplitPane
        defaultSize={width}
        css={css`
          & > .Resizer.vertical {
            padding-left: 10px;
            padding-right: 10px;
            border-right: 1px solid ${customColors.border.primary};
            background-color: ${customColors.bg.primary};
          }
          & > .Pane2 {
            overflow-y: auto;
            background-color: ${customColors.bg.primary};
          }
          & > .Pane1 {
            background-color: ${customColors.bg.primary};
          }
        `}
        onDragFinished={setWidth}
      >
        <InsightsL3Nav />
        {children}
      </SplitPane>
    </div>
  );
};
